import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n/config';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store, { persistor } from "./MyComponents/store";
import showResults from "./MyComponents/showResults";
import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/integration/react';
import WizardPersonalAccount from './MyComponents/Register/PersonalAccount/WizardPersonalAccount';
import { BrowserRouter } from 'react-router-dom'
import ErrorBoundary from 'MyComponents/ErrorBoundary';
import { StyledEngineProvider } from '@mui/material/styles';
import { ToastBox } from 'MyComponents/Toaster';


// import './css/bootstrap.scss';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <ErrorBoundary>
    <Provider store={store} >
    <PersistGate loading={null} persistor={persistor}>
    <StyledEngineProvider>
      <ToastBox/>
      <App />
    </StyledEngineProvider>
    </PersistGate>
    </Provider>
  </ErrorBoundary>
);

reportWebVitals();
